import { FAQ_ALL, faqItems } from '../content/faq';

import { btnDemo } from '../components/cta';
import { faqAccordion } from '../components/faq-accordion';
import { icon } from '../components/icons';
import { eyebrow, mesh } from '../components/primitives';
import { ctaBand, northAmerica } from '../components/sections';
import { routeHref } from '../lib/links';

/* ============================ SOLUTIONS ============================ */
const SEGMENTS = [
  {
    id: 'advisory',
    n: '01',
    label: 'Advisory &amp; Valuation Firms',
    icon: 'building',
    h: 'Governed workflows across offices and markets.',
    pts: [
      'Configure workflows around different offices, markets, roles and approval requirements while maintaining a shared enterprise foundation.',
      'Human approval gates and auditability for AI-assisted work.',
      'Portfolio-level visibility for practice leaders.',
    ],
  },
  {
    id: 'practices',
    n: '02',
    label: 'Property Tax Practices',
    icon: 'listChecks',
    h: 'More capacity without changing your methodology.',
    pts: [
      'Intelligent Intake and Document Intelligence reduce manual intake and document handling.',
      'Deadlines, evidence and settlement activity in one operating environment.',
      'Professionals stay responsible for decisions requiring judgment.',
    ],
  },
  {
    id: 'cre-portfolios',
    n: '03',
    label: 'Enterprise CRE Portfolios',
    icon: 'layers',
    h: 'Portfolio visibility from organization to parcel.',
    pts: [
      'Reporting &amp; Portfolio Intelligence across Organization → Office → Market / Jurisdiction → Client → Property → Parcel → Case.',
      'Client Portal &amp; Portfolio Experience for controlled visibility.',
      'Billing &amp; Financials and savings tracking in the same system.',
    ],
  },
] as const;
export function pageSolutions(): string {
  return `
  <section class="hero compact" aria-labelledby="h1">
    ${mesh()}
    <div class="wrap rv">
      ${eyebrow('Solutions')}
      <h1 id="h1">Configured around <span class="grad">your organization.</span></h1>
      <p class="lede" style="margin-top:24px">Every firm works a little differently. The foundation doesn't. ReTax360 is configured around how advisory firms, property tax practices and enterprise portfolios actually operate.</p>
    </div>
  </section>
  <nav class="subnav" aria-label="Segments">
    <div class="wrap">
      ${SEGMENTS.map((s) => `<a href="${routeHref('/solutions#' + s.id)}" data-sub="${s.id}"><span class="n">${s.n}</span>${s.label}</a>`).join('')}
      <a href="${routeHref('/solutions#faq')}" data-sub="faq"><span class="n">04</span>Enterprise FAQ</a>
    </div>
  </nav>
  ${SEGMENTS.map(
    (s) => `
  <section class="seg" id="${s.id}" aria-labelledby="${s.id}-h">
    <div class="wrap seg-row">
      <div class="rv">${eyebrow(s.n + ' · ' + s.label)}<h2 id="${s.id}-h" style="margin:16px 0 28px">${s.h}</h2>${btnDemo()}</div>
      <div class="card rv" style="--d:80ms"><span class="ic-tile">${icon(s.icon)}</span><ul class="checks" style="margin-top:0">${s.pts.map((p) => `<li>${icon('checkCircle')}<span>${p}</span></li>`).join('')}</ul></div>
    </div>
  </section>`,
  ).join('')}
  ${northAmerica({ compact: true })}
  <section class="s alt" id="faq" aria-labelledby="faq-h">
    <div class="wrap narrow">
      <div class="head rv">${eyebrow('Enterprise FAQ')}<h2 id="faq-h">Questions enterprise evaluators ask.</h2></div>
      <div class="rv">${faqAccordion(faqItems(FAQ_ALL), 'sfaq')}</div>
    </div>
  </section>
  ${ctaBand()}`;
}
